// extracted by mini-css-extract-plugin
module.exports = {"controls":"DescriptionEdit_controls__3-Doh","field":"DescriptionEdit_field__2n3ef"};